import React, { createContext, useContext, useState, useEffect } from 'react';

const EmployeeContext = createContext();

export const EmployeeProvider = ({ children }) => {
  const [employeeID, setEmployeeID] = useState(() => {
    return localStorage.getItem('employeeID') || null;
  });

  useEffect(() => {
    if (employeeID) {
      localStorage.setItem('employeeID', employeeID);
    } else {
      localStorage.removeItem('employeeID');
    }
  }, [employeeID]);

  return (
    <EmployeeContext.Provider value={{ employeeID, setEmployeeID }}>
      {children}
    </EmployeeContext.Provider>
  );
};

export const useEmployee = () => {
  const context = useContext(EmployeeContext);
  if (!context) {
    throw new Error('useEmployee must be used within an EmployeeProvider');
  }
  return context;
};